import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://dompryce.com";
const DEFAULT_TITLE = "Dompryce | Domain Price Compare, Find cheap domains";
const DEFAULT_DESC =
  "Side-by-side domain price comparison across various hosts. Find the cheapest domain registration, renewals and bundles — plus AI-powered name generation.";
const DEFAULT_IMG = `${SITE}/og-cover.png`;

/**
 * Drop-in <Seo /> for every page.
 * Renders <title>, meta description, canonical, OG and Twitter tags
 * plus an optional JSON-LD structured data block.
 */
export default function Seo({
  title,
  description,
  path = "/",
  image = DEFAULT_IMG,
  keywords,
  type = "website",
  jsonLd,
  noindex = false,
}) {
  const finalTitle = title
    ? `${title} · Dompryce`
    : DEFAULT_TITLE;
  const finalDesc = description || DEFAULT_DESC;
  const url = `${SITE}${path}`;

  return (
    <Helmet>
      <title>{finalTitle}</title>
      <meta name="description" content={finalDesc} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDesc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Dompryce" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDesc} />
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
}
